import * as Mod1 from "./discourse/assigned-group-route-map";
import * as Mod2 from "./discourse/assigned-messages-route-map";
import * as Mod3 from "./discourse/assigns-activity-route-map";
import * as Mod4 from "./discourse/components/assign-actions-dropdown";
import * as Mod5 from "./discourse/components/assign-button";
import * as Mod6 from "./discourse/components/assign-user-form";
import * as Mod7 from "./discourse/components/assigned-to-first-post";
import * as Mod8 from "./discourse/components/assigned-to-post";
import * as Mod9 from "./discourse/components/assigned-to";
import * as Mod10 from "./discourse/components/assigned-topic-list-column";
import * as Mod11 from "./discourse/components/assignment-chooser";
import * as Mod12 from "./discourse/components/assignment";
import * as Mod13 from "./discourse/components/bulk-actions/bulk-assign-user";
import * as Mod14 from "./discourse/components/group-assigned-filter";
import * as Mod15 from "./discourse/components/group-assigned-menu-item";
import * as Mod16 from "./discourse/components/modal/assign-user";
import * as Mod17 from "./discourse/components/modal/edit-topic-assignments";
import * as Mod18 from "./discourse/components/post-assignments-display";
import * as Mod19 from "./discourse/components/remind-assigns-frequency";
import * as Mod20 from "./discourse/components/topic-assignments";
import * as Mod21 from "./discourse/components/topic-level-assign-menu";
import * as Mod22 from "./discourse/components/user-menu/assigns-list-empty-state";
import * as Mod23 from "./discourse/components/user-menu/assigns-list";
import * as Mod24 from "./discourse/connectors/above-review-filters/assigned-to-filter.gjs";
import * as Mod25 from "./discourse/connectors/advanced-search-options-below/assigned-advanced-search.gjs";
import * as Mod26 from "./discourse/connectors/category-custom-settings/assign-settings-upsert.gjs";
import * as Mod27 from "./discourse/connectors/group-reports-nav-item/assigned-topic-list.gjs";
import * as Mod28 from "./discourse/connectors/groups-interaction-custom-options/assignable-interaction-fields.gjs";
import * as Mod29 from "./discourse/connectors/user-activity-bottom/assigned-list.gjs";
import * as Mod30 from "./discourse/connectors/user-preferences-notifications/remind-assigns-frequency.gjs";
import * as Mod31 from "./discourse/connectors/user-preferences-tracking-topics/notification-level-when-assigned.gjs";
import * as Mod32 from "./discourse/controllers/group/assigned";
import * as Mod33 from "./discourse/controllers/group/assigned/show";
import * as Mod34 from "./discourse/controllers/user-activity/assigned";
import * as Mod35 from "./discourse/initializers/assign-admin-plugin-configuration-nav";
import * as Mod36 from "./discourse/initializers/assign-extend-user-messages";
import * as Mod37 from "./discourse/initializers/assign-user-menu";
import * as Mod38 from "./discourse/initializers/assignment-list-actions";
import * as Mod39 from "./discourse/initializers/extend-for-assigns";
import * as Mod40 from "./discourse/lib/assignment-payload";
import * as Mod41 from "./discourse/lib/url";
import * as Mod42 from "./discourse/models/assignment";
import * as Mod43 from "./discourse/models/topic";
import * as Mod44 from "./discourse/pre-initializers/extend-category-for-assign";
import * as Mod45 from "./discourse/routes/group/assigned";
import * as Mod46 from "./discourse/routes/group/assigned/show";
import * as Mod47 from "./discourse/routes/user-activity/assigned";
import * as Mod48 from "./discourse/routes/user-private-messages/assigned";
import * as Mod49 from "./discourse/routes/user-private-messages/assigned/index";
import * as Mod50 from "./discourse/services/task-actions";
import * as Mod51 from "./discourse/templates/group/assigned";
import * as Mod52 from "./discourse/templates/group/assigned/show";
import * as Mod53 from "./discourse/templates/user-activity/assigned";
import * as Mod54 from "./discourse/templates/user-private-messages/assigned";
const compatModules = {
  "discourse/assigned-group-route-map": Mod1,
  "discourse/assigned-messages-route-map": Mod2,
  "discourse/assigns-activity-route-map": Mod3,
  "discourse/components/assign-actions-dropdown": Mod4,
  "discourse/components/assign-button": Mod5,
  "discourse/components/assign-user-form": Mod6,
  "discourse/components/assigned-to-first-post": Mod7,
  "discourse/components/assigned-to-post": Mod8,
  "discourse/components/assigned-to": Mod9,
  "discourse/components/assigned-topic-list-column": Mod10,
  "discourse/components/assignment-chooser": Mod11,
  "discourse/components/assignment": Mod12,
  "discourse/components/bulk-actions/bulk-assign-user": Mod13,
  "discourse/components/group-assigned-filter": Mod14,
  "discourse/components/group-assigned-menu-item": Mod15,
  "discourse/components/modal/assign-user": Mod16,
  "discourse/components/modal/edit-topic-assignments": Mod17,
  "discourse/components/post-assignments-display": Mod18,
  "discourse/components/remind-assigns-frequency": Mod19,
  "discourse/components/topic-assignments": Mod20,
  "discourse/components/topic-level-assign-menu": Mod21,
  "discourse/components/user-menu/assigns-list-empty-state": Mod22,
  "discourse/components/user-menu/assigns-list": Mod23,
  "discourse/connectors/above-review-filters/assigned-to-filter": Mod24,
  "discourse/connectors/advanced-search-options-below/assigned-advanced-search": Mod25,
  "discourse/connectors/category-custom-settings/assign-settings-upsert": Mod26,
  "discourse/connectors/group-reports-nav-item/assigned-topic-list": Mod27,
  "discourse/connectors/groups-interaction-custom-options/assignable-interaction-fields": Mod28,
  "discourse/connectors/user-activity-bottom/assigned-list": Mod29,
  "discourse/connectors/user-preferences-notifications/remind-assigns-frequency": Mod30,
  "discourse/connectors/user-preferences-tracking-topics/notification-level-when-assigned": Mod31,
  "discourse/controllers/group/assigned": Mod32,
  "discourse/controllers/group/assigned/show": Mod33,
  "discourse/controllers/user-activity/assigned": Mod34,
  "discourse/initializers/assign-admin-plugin-configuration-nav": Mod35,
  "discourse/initializers/assign-extend-user-messages": Mod36,
  "discourse/initializers/assign-user-menu": Mod37,
  "discourse/initializers/assignment-list-actions": Mod38,
  "discourse/initializers/extend-for-assigns": Mod39,
  "discourse/lib/assignment-payload": Mod40,
  "discourse/lib/url": Mod41,
  "discourse/models/assignment": Mod42,
  "discourse/models/topic": Mod43,
  "discourse/pre-initializers/extend-category-for-assign": Mod44,
  "discourse/routes/group/assigned": Mod45,
  "discourse/routes/group/assigned/show": Mod46,
  "discourse/routes/user-activity/assigned": Mod47,
  "discourse/routes/user-private-messages/assigned": Mod48,
  "discourse/routes/user-private-messages/assigned/index": Mod49,
  "discourse/services/task-actions": Mod50,
  "discourse/templates/group/assigned": Mod51,
  "discourse/templates/group/assigned/show": Mod52,
  "discourse/templates/user-activity/assigned": Mod53,
  "discourse/templates/user-private-messages/assigned": Mod54,
};
export { compatModules };
export default compatModules;
